/* eslint-disable react/no-array-index-key */
import React from 'react';
import styles from './Release.module.css';
import { Image, standards } from '../../../../../components';

export default function Release(props) {
  const { sharedStates } = props;
  
  return (
    <section className={styles.container}>
      <div className={styles.image}>
        <Image
          src={sharedStates.space.imagesPaths[sharedStates.space.imagesPaths.length-1]}
          alt={`Foto de ${sharedStates.space.name}`}
          rounded
          circledColor={standards.colors.red.weak}
          bottomShadow
        />
      </div>
      <div className={styles.messageBox}>
        <p className={styles.message}>
          O espaço
          {' '}
          <span className={styles.spaceName}>{sharedStates.space.name}</span>
          {' '}
          foi notificado e a fatura chegará automaticamente no seu e-mail nos próximos minutos.
        </p>
      </div>
    </section>
  );
}
